import { AiPointerButton } from '@belong/ai-pointer';
import { formatMoney } from '@belong/common';
import { getMaintenanceBudgetHelp } from 'accounts/components/yearly-wealth-dashboard/yearly-wealth-dashboard.strings';
import {
  getMaintenanceExpense,
  useWealthAnalysis,
} from 'accounts/hooks/wealth-analysis';
import { BudgetMeter } from 'maintenance/components/budget-meter/budget-meter';
import { STRINGS } from 'maintenance/strings';

type Props = {
  homeId?: string | null;
  layout?: 'stacked' | 'inline';
  className?: string;
};

export function MaintenanceBudget({ homeId, layout, className }: Props) {
  const { wealthAnalysis, year } = useWealthAnalysis(homeId);
  const expense = getMaintenanceExpense(wealthAnalysis);

  if (!wealthAnalysis?.isPublished || !expense || expense.budget === 0) {
    return null;
  }

  const { budget, spent } = expense;

  return (
    <BudgetMeter
      className={className}
      layout={layout}
      title={STRINGS['maintenance-budget']}
      used={spent}
      budget={budget}
      titleAddon={
        <AiPointerButton
          inline
          help={getMaintenanceBudgetHelp({
            year,
            value: formatMoney(budget, 'DOLLARS_NO_CENTS'),
          })}
        />
      }
    />
  );
}
